import type { FC } from 'react'
import { Outlet } from 'react-router-dom'

import { isNative } from '@dhl/webview'
import { usePushNotificationsSync } from '~/hooks/usePushNotificationsSync.js'

export const WithNotificationSync: FC = () => {
  // eslint-disable-next-line n/no-sync -- shortcut for synchronization, not to indicate it is non-async method
  usePushNotificationsSync({ isEnabled: isNative() })

  return <Outlet />
}
